export const props = {
  // Values
  alt: String,
  src: String
}
